import React from 'react';

import { Th, useTheme, Flex, Menu, MenuButton } from '@chakra-ui/react';
import styled from '@emotion/styled';

import { ChevronDown } from 'assets/assetsV1/iconComponents/ChevronDown';

import { TextBodyMedium } from 'uiToolkitV1/Typography';

const StyledTh = styled(Th)`
  text-transform: inherit;
  padding: 8px 12px;
  border: none;
  min-width: 130px;

  &:first-of-type {
    border-radius: 4px 0 0 4px;
  }

  &:last-of-type {
    border-radius: 0 4px 4px 0;
  }
`;
const CellOption = styled.div`
  position: relative;
  margin-left: auto;
`;

const OptionSelect = styled('div')(({ theme }) => ({
  position: 'absolute',
  width: '5px',
  height: '5px',
  background: theme.colors.alerts.negative,
  borderRadius: '50%',
  right: '3px',
  top: '3px',
}));

const TableHeaderCell = ({
  withOptions = false,
  optionSelected = false,
  optionsMenuList,
  isOptionsMenuOpen = false,
  onOptionsBtnClick,
  children,
  width,
  ...props
}) => {
  const theme = useTheme();

  return (
    <StyledTh width={width} {...props}>
      <Flex justifyContent="space-between">
        <TextBodyMedium color={theme.colors.text.g1}>{children}</TextBodyMedium>
        {withOptions ? (
          <Menu isOpen={isOptionsMenuOpen} closeOnSelect={false}>
            <MenuButton onClick={onOptionsBtnClick}>
              <CellOption>
                {optionSelected && <OptionSelect />}
                <ChevronDown sx={{ cursor: 'pointer' }} color={theme.colors.secondary['666666']} boxSize="20px" />
              </CellOption>
            </MenuButton>
            {optionsMenuList}
          </Menu>
        ) : null}
      </Flex>
    </StyledTh>
  );
};

export { TableHeaderCell };
